import { AxiosError } from "axios";
import Vapor from "laravel-vapor";

import { localStorageService } from "@services/index";
import { FileModelDto, FileModel } from "@interfaces/index";

class AttachmentsService {
  async getAttachments(files: FileList): Promise<FileModel[] | string> {
    const filesArray: File[] = [...files];
    const token = localStorageService.getToken() || "";

    try {
      const uploadedFiles: FileModelDto[] = await Promise.all(
        filesArray.map(async (file: File) => {
          const response = await Vapor.store(file, {
            data: {
              size: file.size,
              type: file.type,
            },
            baseURL: import.meta.env.VITE_API_URL,
            headers: { Authorization: `Bearer ${token}` },
            // uncomment for local testing of attachments
            // baseURL: "https://back.dev.fbtc.co.uk/api",
            // headers: {
            //   Authorization: `Bearer 2211|xqu02reSVpXLYH5HLB6wQtIMmrpqVzBOrfkhLYp06c7cd946`,
            // },
          });

          return {
            key: response.key,
            uuid: response.uuid,
            original_name: file.name,
          };
        }),
      );

      return uploadedFiles.map((file) => ({
        key: file.key,
        uuid: file.uuid,
        originalName: file.original_name,
      }));
    } catch (error) {
      const axiosError = error as AxiosError;
      const errorData = axiosError.response?.data as {
        errors?: { size?: string[] };
      };
      const sizeError =
        !!errorData?.errors?.size?.[0] &&
        "Error! Please ensure that the uploaded file does not exceed 15MB.";
      const errorMessage =
        sizeError || "Unexpected Error with Attachments Service!";
      return errorMessage;
    }
  }
}

export const attachmentsService = new AttachmentsService();
